<template>
    <rkm-form ref="Form">
        <rkm-area
            type="section"
            title="BUSCAR JORNADAS CADASTRADAS"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="jornada.periodo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário Inicial"
                        v-model="jornada.horaInicial"
                    />
                </rkm-col>
                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário Final"
                        v-model="jornada.horaFim"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col cols="auto">
                    <rkm-form-checkbox-group
                        label="Dias da semana"
                        v-model="jornada.diasSemana"
                        :options="form.diasSemana"
                        :validations="validations.diasSemana"
                        min-width="6"
                        text-field="descricao"
                        value-field="id"
                        buttons
                        button-color="outline-primary"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>
                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>
     </rkm-form>
</template>

<script>

// Moment.
import moment from 'moment'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    computed:{
        validations() {
            return {
                diasSemana: { required: true },
            }
        },
    },
    created() {

        this.load();
    },
    data:() => ({
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            diasSemana: null,
            semanaId: null,
            periodo: {
                start: null,
                end: null,
            },
        },
        dataAtual: '',
    }),
    methods:{
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.dataAtual = this.form.dataAtual
        },
        search() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                        let buscaJornada = []

                        this.jornada.diasSemana.forEach(diasSemana => {

                            this.model.jornadas.filter(a => a.geralDiaSemanaId == diasSemana).map(aplicacao => {

                                buscaJornada.push(aplicacao)
                            })
                        })

                        if (this.jornada.horaInicial){

                            buscaJornada = buscaJornada.filter(jornada =>
                                jornada.dataInicial.substr(11, 5) == this.jornada.horaInicial.substr(0, 5))
                        }

                        if (this.jornada.horaFim){
                            buscaJornada = buscaJornada.filter(jornada =>
                                jornada.dataFinal.substr(11, 5) == this.jornada.horaFim.substr(0, 5))
                        }

                        if (this.jornada.periodo){

                            const start = moment(this.jornada.periodo.start).subtract(1, 'day')
                            const end = moment(this.jornada.periodo.end).add(1, 'day')

                            buscaJornada = buscaJornada.filter(jornada => moment(jornada.dataInicial, 'YYYY-MM-DD').isBetween(start, end))
                            buscaJornada = buscaJornada.filter(jornada => moment(jornada.dataFinal, 'YYYY-MM-DD').isBetween(start, end))
                        }

                        this.model.jornadasNotSave = buscaJornada
                        this.$emit('handleBlur')
            })
        },
        validate() {

            return this.$refs.Form.validate()
        },
        resetForm() {

            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''

            this.model.jornadasNotSave = null

            this.$emit('handleBlur')

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        setDefaultValues() {

            this.jornada.periodo.start = moment(this.form.dataAtual, 'YYYY-MM-DD').toDate()
            this.jornada.periodo.end = moment(this.form.dataAtual, 'YYYY-MM-DD').toDate()
        },
        disabledSemanas(){

            this.form.diasSemana.forEach(s => s.disabled = true)
        }
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        tabIndex: { type: Number },
    },
    watch: {
        'jornada.periodo': {
            deep: true,
            handler: function (periodo) {

                this.jornada.diasSemana = []
                this.disabledSemanas()

                if(periodo.end){

                    var periodoInicial = moment(periodo.start, 'YYYY/MM/DD');
                    var periodoFinal = moment(periodo.end, 'YYYY/MM/DD');

                    var diaInicial   = periodoInicial.format('D');
                    var mesInicial = periodoInicial.format('M');
                    var anoInicial  = periodoInicial.format('YYYY');

                    var diaFinal   = periodoFinal.format('D');
                    var mesFinal = periodoFinal.format('M');
                    var anoFinal  = periodoFinal.format('YYYY');

                    var dataInicial = new Date(anoInicial,mesInicial - 1,diaInicial);
                    var dataFim = new Date(anoFinal,mesFinal -1 ,diaFinal);

                    for (var dataInserida = dataInicial; dataInserida <= dataFim; dataInserida.setDate(dataInserida.getDate() + 1)) {

                        var data = moment(dataInserida, 'DD/MM/YYYY').toDate()

                        var dia = data.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == dia)){

                            this.jornada.diasSemana.push(dia)
                        }
                    }

                } else {

                    if(periodo.start){

                        var dataStart = moment(periodo.start, 'DD/MM/YYYY').toDate()

                        var diaStart = dataStart.getDay() + 1;

                        if(!this.jornada.diasSemana.find(d => d == diaStart)){

                            this.jornada.diasSemana.push(diaStart)
                        }
                    }
                }

                if(periodo.start || periodo.end){

                    let indices = []

                    if(periodo.start){

                        let dataStart = moment(periodo.start, 'YYYY-MM-DD').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.end){

                        let dataEnd = moment(periodo.end, 'YYYY-MM-DD').toDate()
                        const index = this.form.diasSemana.findIndex(d => d.id == dataEnd.getDay() + 1)
                        indices.push(index)
                    }

                    if(periodo.start && periodo.end){

                        indices = []

                        let dataStart = moment(periodo.start, 'YYYY-MM-DD')
                        let dataEnd = moment(periodo.end, 'YYYY-MM-DD')

                        let indice = 0

                        while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                            const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                            indices.push(index)

                            dataStart.add(1, 'd')

                            indice++
                        }
                    }

                    indices.forEach(indice => {

                        this.form.diasSemana[indice].disabled = false
                    })
                }
            }
        },
        'tabIndex': function () {

            this.jornada.periodo.start = this.form.dataAtual
            this.jornada.periodo.end  = this.form.dataAtual

            this.$nextTick().then(() => {

                this.jornada.diasSemana = []
                this.disabledSemanas()

                let indices = []
                let start = moment(this.jornada.periodo.start, 'YYYY-MM-DD').toDate()

                const indexStart = this.form.diasSemana.findIndex(d => d.id == start.getDay() + 1)
                indices.push(indexStart)

                let end = moment(this.jornada.periodo.end, 'YYYY-MM-DD').toDate()
                const indexEnd = this.form.diasSemana.findIndex(d => d.id == end.getDay() + 1)
                indices.push(indexEnd)

                let dataStart = moment(this.jornada.periodo.start, 'YYYY-MM-DD')
                let dataEnd = moment(this.jornada.periodo.end, 'YYYY-MM-DD')

                if (dataStart.isSameOrBefore(dataEnd)) {

                    let indice = 0
                    indices = []

                    while (dataStart.isSameOrBefore(dataEnd) && indice < 7) {

                        const index = this.form.diasSemana.findIndex(d => d.id == dataStart.toDate().getDay() + 1)
                        indices.push(index)

                        dataStart.add(1, 'd')

                        indice++
                    }
                }

                indices.forEach(indice => {

                    this.jornada.diasSemana.push(indice + 1)

                    this.form.diasSemana[indice].disabled = false
                })
            })
        },
    }
}
</script>